<template>
  <!-- /Bank Statutory Tab -->
  <div id="payroll_benefits" class="pro-overview tab-pane fade">
    <div class="row">
      <div class="col-md-12 col-lg-6 d-flex">
        <div class="card card-float-dow profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">Payroll information</h3>
          </div>
          <div class="card-body">
            <ul class="personal-info">
              <li>
                <div class="title">Salary Grade</div>
                <div class="text">{{ salaryGrade?.grade || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Salary Type</div>
                <div class="text">{{ salaryType?.salary_type || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Hired Salary</div>
                <div class="text">
                  {{ payrollInformation?.hired_salary || "N/A" }}
                </div>
              </li>
              <li>
                <div class="title">Gross Salary</div>
                <div class="text">
                  {{ payrollInformation?.gross_salary || "N/A" }}
                </div>
              </li>
              <li>
                <div class="title">Basic Salary</div>
                <div class="text">
                  {{ payrollInformation?.basic_salary || "N/A" }}
                </div>
              </li>
              <li>
                <div class="title">Medical/OPD Allowance</div>
                <div class="text">
                  {{ payrollInformation?.medical_allowance || "N/A" }}
                </div>
              </li>
              <li>
                <div class="title">Utility Allowance</div>
                <div class="text">
                  {{ payrollInformation?.utility_allowance || "N/A" }}
                </div>
              </li>
              <li>
                <div class="title">House Rent</div>
                <div class="text">
                  {{ payrollInformation?.house_rent || "N/A" }}
                </div>
              </li>
              <li>
                <div class="title">Salary Tax</div>
                <div class="text">
                  {{ payrollInformation?.salary_tax || "N/A" }}
                </div>
              </li>
              <!-- <li v-for="(raise, index) in salaryRaises" :key="raise.id">
                <div class="title">{{ index + 1 }} Salary Raise</div>
                <div class="text">{{ raise.salary_raise }}</div>
              </li> -->
              <li v-if="payrollInformation?.incentive != null">
                <div class="title">Incentive</div>
                <div class="text">
                  {{ payrollInformation?.incentive || "N/A" }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6 d-flex">
        <div class="card card-float-u profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">Salary Slips</h3>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-nowrap table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Year</th>
                    <th>Month</th>
                    <th>Division</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody v-if="salarySlips.length > 0">
                  <tr v-for="slip in salarySlips" :key="slip.id">
                    <td>{{ slip?.payroll?.year }}</td>
                    <td style="text-transform: capitalize">
                      {{ slip?.payroll?.month }}
                    </td>
                    <td>{{ slip?.payroll?.division_name?.name }}</td>
                    <td class="text-center">
                      <router-link
                        :to="`/payroll-management/payroll/salary-slip-user-view/${slip.id}`"
                      >
                        <img
                          :src="require(`@/assets/img/icons/eye.svg`)"
                          alt="Eye Icon"
                        />
                      </router-link>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="text-center">
                    <td colSpan="4">No Record</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6 d-flex">
        <div class="card card-float-dow profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">Benefits information</h3>
          </div>
          <div class="card-body">
            <ul class="personal-info">
              <li>
                <div class="title">Provident Fund</div>
                <div class="text">{{ benefits?.provident_fund || "N/A" }}</div>
              </li>
              <li>
                <div class="title">EOBI</div>
                <div class="text">{{ benefits?.eobi || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Company Transport</div>
                <div class="text">
                  {{ benefits?.company_transport ? "Yes" : "No" }}
                </div>
              </li>
              <li>
                <div class="title">Health Insurance</div>
                <div class="text">
                  {{ benefits?.health_insurance ? "Yes" : "No" }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6 d-flex">
        <div class="card card-float-dow profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">Other information</h3>
          </div>
          <div class="card-body">
            <ul class="personal-info">
              <li>
                {{ payrollInformation.employee_card_status }}
                <div class="title">Employee Card Status</div>
                <div class="text">
                  {{
                    payrollInformation.other_benefit?.employee_card_status
                      ? "Yes"
                      : "No"
                  }}
                </div>
              </li>
              <li>
                <div class="title">Health Insurance Card Status</div>
                <div class="text">
                  {{
                    payrollInformation?.other_benefit
                      ?.health_insurance_card_status
                      ? "Yes"
                      : "No"
                  }}
                </div>
              </li>
              <li>
                <div class="title">Discount Card</div>
                <div class="text">
                  {{
                    payrollInformation?.other_benefit?.discount_card_status
                      ? "Yes"
                      : "No"
                  }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6 d-flex">
        <div class="card card-float-dow profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">EOBI</h3>
          </div>
          <div class="card-body">
            <div class="table-responsive sticky-summary-table">
              <table class="table table-nowrap table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Year</th>
                    <th>Month</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in reversedEobiProvident" :key="item.id">
                    <td>{{ item.payroll.year }}</td>
                    <td>{{ item.payroll.month }}</td>
                    <td>{{ item.eobi }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td>Total</td>
                    <td></td>
                    <td>{{ this.eobiSum }}</td>
                  </tr>

                  <tr>
                    <td>Company Contribution</td>
                    <td></td>
                    <td>{{ this.eobiSum * 5 }}</td>
                  </tr>

                  <tr>
                    <td>Grand Total</td>
                    <td></td>
                    <td>{{ this.eobiSum + this.eobiSum * 5 }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6 d-flex">
        <div class="card card-float-dow profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">Provident Fund</h3>
          </div>
          <div class="card-body">
            <div class="table-responsive sticky-summary-table">
              <table class="table table-nowrap table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Year</th>
                    <th>Month</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in reversedEobiProvident" :key="item.id">
                    <td>{{ item.payroll.year }}</td>
                    <td>{{ item.payroll.month }}</td>
                    <td>{{ item.provident_fund }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td>Total</td>
                    <td></td>
                    <td>{{ this.providentSum }}</td>
                  </tr>

                  <tr>
                    <td>Company Contribution</td>
                    <td></td>
                    <td>{{ this.providentSum }}</td>
                  </tr>

                  <tr>
                    <td>Grand Total</td>
                    <td></td>
                    <td>{{ this.providentSum + this.providentSum }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-lg-12 d-flex">
        <div class="card card-float-u profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">Account Details</h3>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-nowrap table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Branch Name</th>
                    <th>Account Title</th>
                    <th>Account No</th>
                    <th>IBAN</th>
                    <th>Branch Code</th>
                    <th>Branch Address</th>
                  </tr>
                </thead>
                <tbody v-if="accounts?.length > 0">
                  <tr v-for="account in accounts" :key="account">
                    <td>{{ account.branch_name }}</td>
                    <td>{{ account.account_title }}</td>
                    <td>{{ account.account_no }}</td>
                    <td>{{ account.iban }}</td>
                    <td>{{ account.branch_code }}</td>
                    <td>{{ account.branch_address }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="6">No Data</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-12 d-flex">
        <div class="card card-float-u profile-box flex-fill">
          <div class="card-header">
            <h3 class="card-title">Increment History</h3>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-nowrap table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Increment</th>
                    <th>Increment Amount</th>
                    <th>Salary Adjustment Type</th>
                    <th>Increment Date</th>
                  </tr>
                </thead>
                <tbody v-if="salaryRaises?.length > 0">
                  <tr v-for="raise in salaryRaises" :key="raise">
                    <td>{{ raise?.increment }}</td>
                    <td>{{ raise?.salary_raise }}</td>
                    <td>
                      {{
                        raise?.raise_type?.split("_")?.join(" ")?.toUpperCase()
                      }}
                    </td>
                    <td>{{ raise?.increment_date }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="4">No Data</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EmployeeSalaryService from "@/services/EmployeeSalaryService";
import EmployeeAccountDetailService from "@/services/EmployeeAccountDetailService";
import EmployeeBenefitService from "@/services/EmployeeBenefitService";
import PayrollService from "@/services/PayrollService";
import SalarySlipsService from "@/services/SalarySlipsService";

export default {
  data() {
    return {
      payrollInformation: {},
      salarySlips: [],
      salaryRaises: [],
      salaryType: {},
      salaryGrade: {},
      accounts: [],
      benefits: {},
      eobiProvident: [],
      eobiSum: 0,
      providentSum: 0,
    };
  },
  props: ["userId"],
  methods: {
    async fetchSalarySlips() {
      try {
        const id = this.userId || this.$store.state.auth.user.employee_id;
        const response = await SalarySlipsService.getEmployeeWiseSalarySlips(
          id,
        );
        this.salarySlips = response?.data?.filter((el) => el?.is_published);
      } catch (error) {
        console.log("error fetching salary slips", error);
      }
    },
  },
  computed: {
    grossSalary() {},
    reversedEobiProvident() {
      return [...this.eobiProvident].reverse();
    },
  },
  async created() {
    try {
      const response = await EmployeeSalaryService.getSalaryInformation(
        this.userId || this.$store.state.auth.user.employee_id,
      );

      const responseAccount = await EmployeeAccountDetailService.getDetails(
        this.userId || this.$store.state.auth.user.employee_id,
      );
      const responseBenefit = await EmployeeBenefitService.getDetails(
        this.userId || this.$store.state.auth.user.employee_id,
      );
      this.payrollInformation = response.data;

      const responseEOBI = await PayrollService.getEobiProvident(
        this.userId || this.$store.state.auth.user.employee_id,
      );

      this.fetchSalarySlips();

      let eobiSum = 0;
      let providentSum = 0;

      this.eobiProvident = responseEOBI?.data || [];

      this.eobiProvident?.forEach((el) => {
        if (Number(el?.eobi)) {
          eobiSum += Number(el?.eobi);
        }

        if (Number(el?.provident_fund)) {
          providentSum += Number(el?.provident_fund);
        }
      });

      this.eobiSum = eobiSum;
      this.providentSum = providentSum;

      this.accounts = responseAccount?.data?.account_details;
      this.salaryRaises = this.payrollInformation?.salary_raises;
      this.salaryType = this.payrollInformation?.salary_type;
      this.salaryGrade = this.payrollInformation?.salary_grade;
      this.benefits = responseBenefit?.data;
    } catch (error) {
      console.log("Error fetching", error);
    }
  },
};
</script>

<style scoped>
.sticky-summary-table {
  max-height: 420px;
  overflow-y: auto;
}

.sticky-summary-table table {
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
}

.sticky-summary-table thead {
  position: sticky;
  top: 0;
  z-index: 2;
}

.sticky-summary-table thead th {
  background-color: #fff;
  border-bottom: 1px solid #dee2e6;
  box-shadow: 0 1px 0 0 #dee2e6;
}

.sticky-summary-table tfoot {
  position: sticky;
  bottom: 0;
  z-index: 2;
}

.sticky-summary-table tfoot td {
  background-color: #fff;
  font-weight: 600;
  border-top: 1px solid #dee2e6;
  box-shadow: 0 -1px 0 0 #dee2e6;
}
</style>
